<template>
<div class="dialogBox">
  <div v-show="step===0" class="form">
    <div class="form-row">
      <div>
        <div>
          <span>*</span>
          省份：
        </div>
        <div>
          <el-select v-model="form.provinceId" @change="provincesSelectChange" filterable placeholder="请选择">
            <el-option v-for="item in provincesSelectList" :key="item.provinceId" :label="item.provinceName" :value="item.provinceId"></el-option>
          </el-select>
        </div>
      </div>
      <div>
        <div>
          <span>*</span>
          考点：
        </div>
        <div>
          <el-select v-model="form.examSiteId"  @change="siteSelectChange" filterable placeholder="请选择">
            <el-option v-for="item in examSiteSelectList" :key="item.examSiteId" :label="item.examSiteName" :value="item.examSiteId"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div>
        <div>
          <span>*</span>
          报考等级：
        </div>
        <div>
          <el-select v-model="subjectLevel" @change="getNotScheduled" multiple clearable  filterable placeholder="请选择">
            <el-option v-for="item in leveSelectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div>
        <div>
          待安排考生：
        </div>
        <div>
          {{personsNumber}}
        </div>
      </div>
    </div>
      <div class="form-date">
        <div v-for="(item,index) in submitList" :key="index"  class="form-date-row">
          <div>
            <div><span>*</span>考试时间：</div>
            <div>
              <el-date-picker
                  v-model="item.dateTimes"
                  type="datetimerange"
                  range-separator="至"
                  @change="getExamSelectList($event,item)"
                  :unlink-panels="true"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div>
            <div><span>*</span>考场：</div>
            <div>
              <el-select v-model="item.examList" @change="getNotScheduled" multiple  filterable placeholder="请选择">
                <el-option v-for="exam in item.examSelectList" :key="exam.value" :label="exam.label" :value="exam.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-date-row-but">
            <!--添加-->
            <i v-if="index===(submitList.length-1)" @click="addRow(index)" class="el-icon-circle-plus"></i>
            <!--删除-->
            <i v-else @click="removeRow(index)" class="el-icon-remove"></i>
          </div>
        </div>
      </div>
  </div>
  <div v-show="step===1" class="table">
    <el-table :data="tableList" tooltip-effect="dark" v-loading="tableIsLoading" border ref="elTable" style="width: 100%;" :header-cell-style="$store.getters.getTableHeadStyle" :height="400" >
      <el-table-column prop="examRoomName" show-overflow-tooltip label="考场" align="center"></el-table-column>
      <el-table-column label="考试时间" width="320" align="center">
        <template slot-scope="{ row }">
          {{row.startTime + '至' + row.endTime }}
        </template>
      </el-table-column>
      <el-table-column prop="person" width="100" label="考试人数" align="center"></el-table-column>
      <el-table-column label="报考等级" show-overflow-tooltip align="center">
        <template slot-scope="{ row }">
          <div>
            <span v-for="(item,index) in row.level" :key="index">
              <span v-if="index!==0">，</span>
              {{item|getLvTextByLv}}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-row type="flex" class="dailogButBox" justify="center">
    <template v-if="step===0">
      <el-button size="medium" @click="$emit('goBack')">取消</el-button>
      <el-button size="medium" type="primary" :loading="tableIsLoading" @click="nextStep">下一步</el-button>
    </template>
    <template v-else>
      <el-button size="medium" @click="step=0">上一步</el-button>
      <Debounce>
        <el-button size="medium" type="primary" :loading="submitIsLoading" @click="submit">确认</el-button>
      </Debounce>
    </template>
  </el-row>
</div>
</template>

<script>
export default {
  name: "examRoomFrom",
  props:['examId'],
  data(){
    return{
      step:0,
      provincesSelectList:[],//省份下拉
      examSiteSelectList:[],//考点下拉
      leveSelectList:[],//报考等级
      form:{
        provinceId:'',
        examSiteId:'',
      },
      subjectLevel:[],//已选的等级
      personsNumber:0,//人数
      submitList:[
        {
          dateTimes:[],//所选考试时间段
          examSelectList:[],//总考场list
          examList:[],//选中的考场
        },
      ],
      tableList:[],
      tableIsLoading:false,
      uuid:'',
      submitIsLoading:false,
    }
  },
  mounted() {
    this.getAllSelectList()
  },
  methods:{
    submit(){
      this.submitIsLoading=true;
      this.$axios.get("/arrange/plan/"+this.uuid).then((res) => {
        this.$message.success('安排成功！')
        this.submitIsLoading=false;
        this.$emit('goBack');
      })
      .catch(err=>{
        this.submitIsLoading=false;
        this.$emit('goBack')
      })
    },
    getAllSelectList(){
      this.$axios.get("/arrange/province/"+this.examId).then((res) => {
        const data = res.data.data;
        this.provincesSelectList=data;
      });
    },
    provincesSelectChange(val){
      this.form.examSiteId='';
      this.subjectLevel=[];
      //如果选择全部省份
      if(!val){
        this.examSiteSelectList=[]
        return
      }
      this.examSiteSelectList=this.provincesSelectList.find(item=>item.provinceId===val).examSiteVOS;
    },
    siteSelectChange(val){
      this.subjectLevel=[];
      if(!val){
        this.leveSelectList=[]
        return
      }
      this.leveSelectList=this.examSiteSelectList.find(item=>item.examSiteId===val).level;
    },
    getNotScheduled(){
      if(!this.subjectLevel || this.subjectLevel.length===0 ){
        this.personsNumber=0;
        return
      }
      this.$axios.post("/arrange/info",{
        ...this.form,
        subjectLevel:this.subjectLevel,
        examId:this.examId,
      }).then((res) => {
        const data = res.data.data;
        this.personsNumber=data;
      });
    },
    //获取所选时间段的考点内所有考场
    getExamSelectList(val,item){
      console.log(val)
      item.examList=[];
      item.examSelectList=[];
      if(!this.form.examSiteId || !this.form.provinceId){
        this.$message.warning('省份考点不可为空！')
        item.dateTimes=[]
        return
      }
      //如果时间选择器无值
      if(!val){
        return
      }
      this.$axios
          .post("/arrange/examRoomSelect/"+this.form.examSiteId,{
            endTime:val[1],
            startTime:val[0],
          })
          .then((res) => {
            const data = res.data.data;
            item.examSelectList=data;
          });
    },
    addRow(index){
      console.log(index)
      let {dateTimes,examList}=this.submitList[index]
      if(!dateTimes || dateTimes.length===0 || !examList || examList.length===0){
        this.$message.warning('请填写完整再添加数据')
        return
      }
      this.submitList.push(
          {
            dateTimes:[],//所选考试时间段
            examSelectList:[],//总考场list
            examList:[],//选中的考场
          }
      )
    },
    removeRow(index){
      this.submitList.splice(index,1);
    },
    nextStep(){
      if(!this.form.examSiteId || !this.form.provinceId || !this.subjectLevel || this.subjectLevel.length===0){
        this.$message.warning('省份考点报考等级不可为空！')
        return
      }
      let examPlanInfo=[],
          canSubmit = true;
      this.submitList.forEach(item=>{
        if(
            !item.dateTimes ||
            item.dateTimes.length==0 ||
            !item.examList ||
            item.examList.length===0
        ){
          canSubmit=false;
        }else{
          examPlanInfo.push({
            endTime:item.dateTimes[1],
            startTime:item.dateTimes[0],
            examRoomList:item.examList,
          })
        }
      })
      if(!canSubmit){
        this.$message.warning('请填写完整考试时间考场数据！')
        return
      }
      this.tableIsLoading=true;
      this.step=1;
      this.$axios
          .post("/arrange/back",{
            examId:this.examId,
            examSiteId:this.form.examSiteId,
            provinceId:this.form.provinceId,
            subjectLevel:this.subjectLevel,
            examPlanInfo:examPlanInfo,
          })
          .then((res) => {
            const data = res.data.data;
            this.tableList=data.info || [];
            this.uuid=data.uuId;
            this.tableIsLoading=false;
          })

    }
  }
}
</script>

<style lang="scss" scoped>
.dialogBox{
  .form{
    max-height: 400px;
    overflow: auto;
    &-row{
      display: flex;
      margin-bottom: 10px;
      &-but{
        width: 100px;
      }
      >div{
        display: flex;
        flex: 1;
        .el-select{
          width: 270px;
        }
        >div:first-child{
          width: 100px;
          text-align: right;
          line-height: 2.5;
          >span{
            color: #f56c6c;
          }
        }
        >div:last-child{
          flex: 1;
          line-height: 2.5;
        }
      }
    }
    &-date{
      max-height: 300px;
      overflow: auto;
      &-row{
        display: flex;
        margin-bottom: 10px;
        >div:nth-child(1),>div:nth-child(2){
          flex: 1;
          display: flex;
          line-height: 2.5;
          >div:first-child{
            width: 100px;
            text-align: right;
            >span{
              color: #f56c6c;
            }
          }
        }
       &-but{
         width: 80px;
         text-align: center;
         font-size: 28px;
         >i{
           cursor: pointer;
         }
         >.el-icon-circle-plus{
           color: #1890ff;
         }
         >.el-icon-remove{
           color: #f56c6c;
         }
       }
      }
    }
  }
}
</style>